import { render, staticRenderFns } from "./ZhongBiao.vue?vue&type=template&id=c24bdeee&scoped=true"
import script from "./ZhongBiao.vue?vue&type=script&lang=js"
export * from "./ZhongBiao.vue?vue&type=script&lang=js"
import style0 from "./ZhongBiao.vue?vue&type=style&index=0&id=c24bdeee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24bdeee",
  null
  
)

export default component.exports